import React from 'react';
import { ISessionVideo } from '../../interfaces/ISessionVideo';
import NetworkNotification from '../NetworkNotification/NetworkNotification';
import './BibleVideos.scss';

export interface IBibleVideosProps {
    videos?: ISessionVideo[];
}

const BibleVideos: React.FC<IBibleVideosProps> = (props) => {
    const sourceUrl = props.videos

    return <div className="bible-videos-root"> 
        {props.videos ? props.videos.map((video, index) => 
            <div className="bible-video-container" key={'bible-video-' + index}>
                <h3>{video.title ? video.title : 'Bible Videos'}</h3>
                <div className={'bible-video-youTube ' + (video.vertical ? 'bible-video-vertical' : '')}>
                    <iframe width={video.vertical ? '315' : '560'} height={video.vertical ? '560' : '315'} title={video.title}
                        src={video.startTime ?
                            `https://www.youtube.com/embed/${video.code}?start=${video.startTime}&rel=0&modestbranding=1&showinfo=0` :
                            `https://www.youtube.com/embed/${video.code}?rel=0&modestbranding=1&showinfo=0`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
                <p className="bible-video-footnote">{video.footnote}</p>
                <div className="bible-video-divider"></div>
            </div>
        ): <div>No Videos Found</div>}
        <NetworkNotification noInternetMessage="NO INTERNET CONNECTION DETECTED - Connection is required to view videos."></NetworkNotification>
    </div>
};

export default BibleVideos;